import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/zszwrsjf',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.instagram.com/zszwrsj123/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/song-zhang-77000223b/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://youtrust.jp/users/a42543368846159b2f7224bca79a34f4',
    label: 'Youtrust',
    iconPath: '/images/youtrust.svg',
  },
];

export default data;
